import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import InsertVehicleType from "../../../components/vehicleTypeComponent/insertVehicleType";
import { translate } from "react-i18next";
import ReadAxios from "../../../components/axiosComponent/read";

class AddVehicleType extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "create.add_title",
      editData: {},
    };
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.title) {
      this.setState({
        title: this.props.location.state.title,
        editData: { ...this.props.location.state },
      });
    }
    if(this?.props?.location?.state?.vehicleTypeId){
      this.setVehicleLoadTypes(this?.props?.location?.state?.vehicleTypeId)
    }
  }

  setVehicleLoadTypes = (vehicleTypeId)=>{
    ReadAxios({
      url:`vehicleTypeLoadTypeMapping`,
      readItems : {
        vehicleTypeId
      }
    }).then((res)=>{
      let mappingData = res?.data?.resultSet
      let loadTypeIds = []
      if(mappingData?.length){
        mappingData.map((data)=>{
          loadTypeIds.push(data.loadTypeId)
        })
      }
      this.setState({editData: { ...this.state.editData, loadTypeIds }})

    })
  }

  onFormSubmit = () => {
    this.props.history.push("/vehicle-type");
    this.props.history.go();
  };

  render() {
    return (
      <React.Fragment>
        <AddTitleBar Title={this.props.t(this.state.title)} LinkName="/vehicle-type" />
        <div className="m-2">
          <InsertVehicleType
            editData={this.state.editData}
            onFormSubmit={this.onFormSubmit}
          />
        </div>
      </React.Fragment>
    );
  }
}
export default translate("vehicle_type")(AddVehicleType);
